export default "__VITE_ASSET__BauRqNKe__"